import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaGlobe, FaCheck } from 'react-icons/fa';
import './languageSwitcher.css';

const LANGUAGES = [
  { code: 'en', badge: 'EN', badgeColor: '#7C3AED', labelKey: 'language.english' },
  { code: 'ar', badge: 'ع', badgeColor: '#9CA3AF', labelKey: 'language.arabic' },
];

const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);
  const current = LANGUAGES.find((lang) => lang.code === i18n.language) || LANGUAGES[0];

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('click', handleOutsideClick);
    return () => document.removeEventListener('click', handleOutsideClick);
  }, []);

  const handleSelect = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div className="lang-switcher" ref={wrapperRef}>
      <button type="button" className="lang-switcher-toggle" onClick={() => setOpen((prev) => !prev)}>
        <FaGlobe size={13} />
        <span>{current.badge}</span>
      </button>
      {open && (
        <div className="lang-switcher-menu">
          {LANGUAGES.map((lang) => (
            <div
              key={lang.code}
              className={`lang-switcher-item${lang.code === current.code ? ' active' : ''}`}
              onClick={() => handleSelect(lang.code)}
            >
              <span className="lang-switcher-badge" style={{ backgroundColor: lang.badgeColor }}>
                {lang.badge}
              </span>
              <span className="lang-switcher-label">{t(lang.labelKey)}</span>
              {lang.code === current.code && <FaCheck className="lang-switcher-check" />}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
